import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// React Router v6 doesn't restore scroll position on navigation the way a
// traditional multi-page site does -- without this, clicking through from
// partway down a long list lands you partway down the next page too.
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
